import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { UserLocation } from '@dvm-monorepo/interfaces/keycloak';
import { inject } from '@angular/core';

export const singleLocationRedirectResolver: ResolveFn<RedirectCommand | boolean> = (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const userLocations = route.parent?.data['userLocations'] as UserLocation[];

    if (userLocations?.length === 1) {
        return new RedirectCommand(router.parseUrl(`/locations/${userLocations[0].id}/scan`));
    }

    return true;
};
